import React from 'react';
import PropTypes from 'prop-types';

import { useGetAppConfigQuery } from 'app/api/mainApi';

import { toCurrency } from 'app/helpers/currencyHelpers';
import { starRating, callButton } from 'app/helpers/listingHelpers';

const DeprecatedPhoneListingCard = ({
  listing,
  headingSource,
  style,
  hideCallButton,
}) => {
  const appConfig = useGetAppConfigQuery().data;
  const currentUser = appConfig?.current_user;
  const listingUrl = `/listings/show/${listing.slug}`;
  const heading = headingSource === 'category' ? listing.full_category : listing.login;

  return (
    <div className="listing" style={style}>
      <div className="container-fluid padding-0-8" role="link" tabIndex="0">
        <div className="row">
          <div className="col-xs-4 padding10 center-xs">
            <a href={listingUrl}>
              <div className="pic">
                <img src={listing.photo_url} alt="Listing Thumbnail" />
              </div>
              <div className="stars">
                {starRating(listing.rating)}
                <p>
                  (
                  {listing.total_ratings}
                  )
                </p>
              </div>
            </a>
          </div>
          <div className="col-xs-8 start-xs padding10">
            <div className="container-fluid padding-0-8">
              <div className="row name">
                <a href={listingUrl}>
                  {heading}
                </a>
              </div>
              <div className="row description">
                <a href={listingUrl}>
                  {listing.title}
                </a>
              </div>
              <div className="row details">
                <div className="col-xs-4 marginlftminus8">
                  <a href={listingUrl}>
                    Details
                  </a>
                </div>
                <div className="col-xs-8 end-xs price">
                  {toCurrency(listing.price_per_minute)}
                  &nbsp;
                  <span>per min.</span>
                </div>
              </div>
              { !hideCallButton && (
                <div className="row margintop20">
                  {callButton({ listing, currentUser })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DeprecatedPhoneListingCard.defaultProps = {
  headingSource: null,
  style: {},
  hideCallButton: false,
};

DeprecatedPhoneListingCard.propTypes = {
  listing: PropTypes.object.isRequired,
  headingSource: PropTypes.string,
  style: PropTypes.object,
  hideCallButton: PropTypes.bool,
};

export default DeprecatedPhoneListingCard;
